import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {RegulatoryDataBox} from "./boxes/regulatory-data.box";
import {HeaderConfiguration} from '../../../../services/configurations/config-data-sections/header.configuration';
import {GamblingWarningComponent} from '../../gambling-warning/gambling-warning.component';
import {ResponsibleIconsComponent} from '../../responsible-icons/responsible-icons.component';
import {ClockAndLastLoginBoxComponent} from '../../../clock-and-last-login-box/clock-and-last-login-box.component';
import {observer} from "mobx-react";
import classNames from "classnames";

interface RegulatoryDataComponentProps {
    attachToHeaderService: boolean;
    className?: string;
}

@observer
export class RegulatoryDataComponent extends OrbitComponent<RegulatoryDataComponentProps> {

    private get _headerConfig(): HeaderConfiguration {
        return this.services.configuration.data.header;
    }

    private _captureHeaderUpperRef = (element: HTMLElement | null) => {
        if (this.props.attachToHeaderService) {
            this.services.header.setHeaderRegulationDataElement(element);
        }
    };

    private _renderMobileLastLogin() {
        if (this.services.device.isMobile) {
            return <ClockAndLastLoginBoxComponent />;
        }

        return null;
    }

    private _getRegulatoryContent() {
        if (this.services.miniOrbit.isCis) {
            return null;
        }


        let gamblingMessageConfig = this._headerConfig.gambling_message;
        let responsibleIconsConfig = this._headerConfig.responsibleIcons;

        if (responsibleIconsConfig && responsibleIconsConfig.display) {
            return <ResponsibleIconsComponent />;
        } else if (gamblingMessageConfig && gamblingMessageConfig.display) {
            return <GamblingWarningComponent />;
        }

        return null;
    };

    render() {
        return (
            <RegulatoryDataBox className={classNames('cy-header-regulation-data', this.props.className)} ref={this._captureHeaderUpperRef}>
                {this._renderMobileLastLogin()}
                {this._getRegulatoryContent()}
            </RegulatoryDataBox>
        );
    }
}
